import React, { useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components/macro';
import { useDispatch } from 'react-redux';
import { Button, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import mediaQuery from 'styles/utils/mediaQuery';
import { loadDepartureAirportsGroupings, loadDestinationAirportsGroupings } from 'common/dataService';
import { loadAndSetAirports, loadAndSetCarriers } from './reducers/options';
import updatePageAndLoadResults from './managers/updatePageAndLoadResults';
import resetFilters from './managers/resetFilters';
import FiltersList from './comp/filtersList';

function FlightRoutesFilters() {
  const { breakpoints } = useContext(ThemeContext);
  const isLargeDevice = useMediaQuery({ minWidth: breakpoints.medium });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadDepartureAirportsGroupings());
    dispatch(loadDestinationAirportsGroupings());
    dispatch(loadAndSetAirports());
    dispatch(loadAndSetCarriers());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetFilters);
    };
  }, []);

  useEffect(() => {
    function onSignout() {
      dispatch(resetFilters);
    }

    document.addEventListener('signout', onSignout);

    return () => {
      document.removeEventListener('signout', onSignout);
    };
  }, [dispatch]);

  function handleOnClickSearch() {
    dispatch(updatePageAndLoadResults(1));
  }

  return (
    <Root>
      <FiltersList isLargeDevice={isLargeDevice} />
      {isLargeDevice && (
        <ActionsWrap>
          <SearchWrap>
            <Tooltip title={<FormattedMessage id='searchFlightRoutesTooltip' />}>
              <SearchButton type='primary' onClick={handleOnClickSearch}>
                <FormattedMessage id='search' />
              </SearchButton>
            </Tooltip>
          </SearchWrap>
        </ActionsWrap>
      )}
    </Root>
  );
}

export default FlightRoutesFilters;

const Root = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SearchWrap = styled.div`
  display: none;

  ${mediaQuery.fromAndAbove.medium`
    display: block;
  `}
`;

const SearchButton = styled(Button)`
  flex: 0 0 auto;
  width: 144px;
`;

const ActionsWrap = styled.div`
  display: none;

  > *:not(:last-child) {
    margin-right: 16px;
  }

  ${mediaQuery.fromAndAbove.medium`
    display: flex;
    align-items: flex-start;
    margin-top: 22px;
  `}
`;
